import React, { useEffect, useState } from "react";
import {
  Box,
  Flex,
  FormLabel,
  Heading,
  VStack,
  Text,
} from "@chakra-ui/react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  closeCreateAssistant,
} from "../../../../modules/admin-modules/models/Actions";
import MainModel from "../../../../components/Models/main-model";
import { useForm } from "react-hook-form";
import MainInput from "../../../../components/Form/input";
import {
  createAssistantRequest,
  editAssistantRequest,
} from "../../../../modules/admin-modules/assistants/Actions";
import { openShowAssistantDataModel } from "../../../../modules/admin-modules/models/Actions";

const AddAssistant = ({ isAdd, data, setSelectedData, setCreatedAssistantData }) => {
  const openAssistant = useSelector((state) => state.model.isOpen41);
  const isLoading = useSelector((state) => state.assistants.isLoading);
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: data ? data : {},
    shouldUnregister: true,
  });

  useEffect(() => {
    if (data && !isAdd) {
      reset({
        name: data.name || "",
        phone: data.phone || "",
      });
    } else {
      reset({ 
        name: "",
        phone: "",
      });
    }
  }, [data, isAdd, reset]);

  const header = (
    <Box>
      <Heading textAlign="center" color="main_1" fontSize="24px">
        {isAdd ? " إضافة أسيستانت" : "تعديل أسيستانت"}
      </Heading>
    </Box>
  );

  const onSubmit = async (formData) => {
    if (!formData.name || !formData.phone) {
      return;
    }
    
    const action = (createdData) => {
      dispatch(closeCreateAssistant());
      setSelectedData({});
      reset();
      if (isAdd && createdData && setCreatedAssistantData) {
        setCreatedAssistantData(createdData);
        dispatch(openShowAssistantDataModel());
      }
    };

    if (isAdd) {
      await dispatch(createAssistantRequest(formData, action));
    } else {
      const result = await dispatch(
        editAssistantRequest({
          id: data?.id,
          formData: formData,
          action: action,
        })
      );
      // Ensure modal closes even if action callback isn't called
      if (result && result.type && result.type.includes('SUCCESS')) {
        action();
      }
    }
  };

  const closeFunc = () => {
    dispatch(closeCreateAssistant());
    setSelectedData({});
    reset();
  };

  return (
    <MainModel
      isLoading={isLoading}
      header={header}
      closeFunc={closeFunc}
      openVar={openAssistant}
      buttonTitle={" حفظ التغيرات"}
      buttonFunc={handleSubmit(onSubmit)}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <VStack dir="rtl" w="100%" alignItems="flex-start" spacing={4}>

          <Box w="100%">
            <MainInput
              label="الاسم"
              error={errors?.name?.message}
              placeholder=" اكتب الاسم"
              register={register}
              name="name"
              required
            />
          </Box>

          <Box w="100%">
            <MainInput
              label="رقم الهاتف"
              error={errors?.phone?.message}
              placeholder=" اكتب رقم الهاتف"
              register={register}
              name="phone"
              required
            />
          </Box>
        </VStack>
      </form>
    </MainModel>
  );
};

export default AddAssistant;

